import React, { useState } from 'react';
import styled from 'styled-components';
import WorkoutApi from '../../../api/workout';
import { WorkoutEditProps } from '../../../types/workout.types';

function WorkoutEditMode(props: WorkoutEditProps) {
  const { id, isCompleted } = props.editWorkouts;
  const [editWorkout, setEditWorkout] = useState('');

  const onEditModeHandler = (e: React.FormEvent<HTMLInputElement>) => setEditWorkout(e.currentTarget.value);
  const onSubmitEditWorkout = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    WorkoutApi.updateWorkout(id, editWorkout, isCompleted);
    props.editState(false); // edit mode 종료
  }

  return (
    <Container onSubmit={onSubmitEditWorkout}>
      <input
        type='text'
        value={editWorkout}
        onChange={onEditModeHandler}
        placeholder='입력 후 Enter로 입력해 주세요.'
      />
    </Container>
  )
}

export default WorkoutEditMode;

const Container = styled.form`
  width: 100%;
  input {
      width: 100%;
      outline: none;
    }
`